import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorkOrdersMaterials(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIALS,
		options
	)
}

function _getWorkOrdersMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIAL,
		options
	)
}

function _createWorkOrdersMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].CREATE_WORK_ORDERS_MATERIAL,
		options
	)
}

function _putWorkOrdersMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PUT_WORK_ORDERS_MATERIAL,
		options
	)
}

function _patchWorkOrdersMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PATCH_WORK_ORDERS_MATERIAL,
		options
	)
}

function _deleteWorkOrdersMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].DELETE_WORK_ORDERS_MATERIAL,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIALS]: _getWorkOrdersMaterials,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIAL]: _getWorkOrdersMaterial,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].CREATE_WORK_ORDERS_MATERIAL]: _createWorkOrdersMaterial,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PUT_WORK_ORDERS_MATERIAL]: _putWorkOrdersMaterial,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PATCH_WORK_ORDERS_MATERIAL]: _patchWorkOrdersMaterial,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].DELETE_WORK_ORDERS_MATERIAL]: _deleteWorkOrdersMaterial,
}